import {
  ActionIcon,
  Avatar,
  Button,
  Divider,
  Group,
  Menu,
  Popover,
  Stack,
  Text,
} from "@mantine/core";
import React, { useMemo } from "react";
import LogoHorizontal from "../../LogoHorizontal";
import { useProfileStore, useSessionStore } from "../../../stores/UserStore";
import LanguageChanger from "../../../pages/unprotected/LanguageChanger";
import { IconChevronDown, IconLogout, IconMenu2 } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import { useLanguage } from "../../../stores/LanguageStore";
import { useNavigate } from "react-router-dom";
import HeaderStatsMobile from "./HeaderStatsMobile";
import AllSwitcher from "../../Footer/AllSwitcher";
import MobileAccountSwitcher from "./MobileAccountSwitcher";

const HeaderMobile = () => {
  const lang = useLanguage((s) => s.language);
  const unswitchedProfile = useProfileStore((s) => s.unswitchedProfile);
  const profile = useProfileStore((s) => s.profile);
  const user_switch = useSessionStore((s) => s.user_switch);

  const canSwitch = useMemo(() => {
    let p = user_switch ? unswitchedProfile : profile;
    if (
      !p?.permissions?.find((x) => x.name === "switchOrganizationUser")
        ?.value &&
      !p?.permissions?.find((x) => x.name === "switchTeamUser")?.value &&
      p?.level === "user"
    ) {
      return false;
    }
    return true;
  }, [user_switch, unswitchedProfile, profile]);

  const navigate = useNavigate();
  const handleLogout = () => {
    function main() {
      let s = useSessionStore.getState();
      s.setUserSwitch(null);
      s.setSession(null);
      let api_url = localStorage.getItem("api_url");

      localStorage.clear();

      window.$chatwoot?.reset();

      setTimeout(() => {
        let p = useProfileStore.getState();
        p.setProfile(null);
        navigate("/login?logged_out=true");

        localStorage.setItem("api_url", api_url);
      }, 50);
    }

    modals.openConfirmModal({
      title: lang.new_header.logout_warning_title,
      children: <Text>{lang.new_header.logout_warning}</Text>,
      labels: {
        confirm: lang.header.menus.logout,
        cancel: lang.components.navigation_blocker.rest,
      },
      confirmProps: { color: "red" },
      onConfirm: main,
      onCancel: () => modals.closeAll(),
    });
  };

  return (
    <Group py={16} px={24} gap={8}>
      <LogoHorizontal width="150" style={{marginRight: "auto"}} />

      <LanguageChanger header isStatic />

      <Popover position="bottom-end" offset={4}>
        <Popover.Target>
          <Group gap={4} wrap="nowrap">
            <Avatar src={profile?.avatar} size={40} />

            <IconChevronDown size={18} />
          </Group>
        </Popover.Target>

        <Popover.Dropdown p={0} style={{ overflow: "hidden" }}>
          <Group gap={4} pl={12} wrap="nowrap">
            <Avatar src={profile?.avatar} size={40} />
            <Stack ml={"sm"} ta={"start"} gap={0} mr={8} c={"black"}>
              <Text fw={600} truncate="end">
                {profile?.first_name} {profile?.last_name}
              </Text>
              <Text opacity={0.5} fz={"sm"}>
                #{profile?.id}
              </Text>
            </Stack>
            {canSwitch && <MobileAccountSwitcher />}
          </Group>

          <Divider opacity={0.25} />

          <HeaderStatsMobile />

          <Divider opacity={0.25} />
          <Button
            onClick={handleLogout}
            color="red"
            variant="subtle"
            size="md"
            radius={0}
            w={"100%"}
          >
            <Group w={"100%"} justify="center">
              <IconLogout size={18} />
              {lang.header.menus.logout}
            </Group>
          </Button>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};

export default HeaderMobile;
